import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/hooks';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { fetchUserProfileAcls } from 'common/services/api/UserProfileAcls/UserProfileAcls.thunk';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { IUserProfileTenant } from 'features/userProfileApps/UserProfileApps';
import { useSnackbar } from 'notistack';

import { selectProcessing,selectUserProfileAclsByTenantId } from '../userProfileAclsSlice';

export const useFetchDefaultUserProfileAcls = (
    tenant: IUserProfileTenant,
    userId: string
) => {
    const { id: tenantId, isLicenseRequired } = tenant;
    const userProfileAcls = useAppSelector(selectUserProfileAclsByTenantId(tenantId));
    const processing = useAppSelector(selectProcessing);
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (userProfileAcls || isLicenseRequired) {
            return;
        }
        const fetchUserProfileAclsParams = {
            tenantId,
            userId
        };
        dispatch(fetchUserProfileAcls(fetchUserProfileAclsParams))
            .catch((error) => {
                handleListFetchError(extractStatusCode(error.message), 'User Profile Acl Entries', enqueueSnackbar);
            });
    }, [tenantId, userId, isLicenseRequired]);

    return {
        defaultUserProfileAcls: userProfileAcls,
        processingDefaultUserProfileAcls: processing === tenantId
    };
};
